import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { Container, Row, Col, OverlayTrigger, Tooltip } from 'react-bootstrap';
import GroceryListModal from './GroceryListModal';

const GroceryLists = ({ onSelectList, onSingleList }) => {
    const [groceryLists, setGroceryLists] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [currentList, setCurrentList] = useState({ name: '', description: '', is_default: null, status: '' });

    const token = localStorage.getItem('token');

    const fetchGroceryLists = useCallback(async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_API_URL}/highgarden/household-grocery-lists/`, {
                headers: {
                    Authorization: `Token ${token}`,
                },
            });
            setGroceryLists(response.data.results);
            if (response.data.results.length > 0) {
                const firstList = response.data.results[0];
                setCurrentList(firstList);
                onSelectList(firstList);  // Automatically select the first list
                if (response.data.results.length === 1 && typeof onSingleList === 'function') {
                    onSingleList(firstList);
                }
            }
        } catch (error) {
            console.error('Error fetching grocery lists:', error);
        }
    }, [token, onSelectList, onSingleList]);

    useEffect(() => {
        fetchGroceryLists();
        document.title = 'Saarthi - Grocery Lists';
    }, [fetchGroceryLists]);

    const handleCloseModal = () => {
        setShowModal(false);
        setCurrentList({ name: '', description: '', is_default: null, status: '' });  // Reset currentList after modal is closed
    };

    // Custom style for the grocery list items
    const listItemStyle = {
        cursor: 'pointer',
        padding: '10px',
        margin: '5px 0',
        border: '1px solid #ffffff',
        borderRadius: '5px',
        transition: 'background-color 0.3s',
        flexDirection: 'column',
        alignItems: 'flex-start',
    };

    // Style for highlighting a list item on hover
    const hoverStyle = {
        backgroundColor: '#f0f0f0',
    };

    const handleSelectList = (list) => {
        setCurrentList(list);  // Update currentList with the selected list
        onSelectList(list);  // Continue to propagate the selection
    };

    const selectedStyle = {
        backgroundColor: '#4b88a2',
        color: 'white',  // Ensuring text is easily readable
        borderRadius: '5px',
    };

    return (
        <Container fluid className="mt-0" style={{ height: '100vh' }}>
            <Row>
                <Col style={{ display: 'flex', flexDirection: 'column', padding: '0', maxWidth: '250px', height: '100vh' }}>
                    <div style={{ flex: 1, overflowY: 'auto', paddingTop: '10px' }}>
                        {groceryLists.length > 0 ? (
                            groceryLists.map(list => (
                                <div
                                    key={list.uuid}
                                    className="mb-3 p-2"
                                    style={currentList && list.uuid === currentList.uuid ? { ...listItemStyle, ...selectedStyle } : listItemStyle}
                                    onClick={() => handleSelectList(list)}
                                    onMouseOver={(e) => {
                                        if (!currentList || list.uuid !== currentList.uuid) {
                                            e.currentTarget.style.backgroundColor = hoverStyle.backgroundColor;
                                        }
                                    }}
                                    onMouseOut={(e) => {
                                        if (!currentList || list.uuid !== currentList.uuid) {
                                            e.currentTarget.style.backgroundColor = 'transparent';
                                        }
                                    }}
                                >
                                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
                                        <h6 style={{ margin: '0' }}>{list.name}</h6>
                                        {list.is_default && (
                                            <OverlayTrigger
                                                placement="top"
                                                overlay={
                                                    <Tooltip id={`tooltip-${list.uuid}`}>
                                                        Default list
                                                    </Tooltip>
                                                }
                                            >
                                                <i className="bi bi-star-fill" style={{ color: 'gold' }}></i>
                                            </OverlayTrigger>
                                        )}
                                    </div>
                                    <p style={{
                                        margin: '0',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                        maxWidth: '100%',
                                    }}>
                                        {list.description}
                                    </p>
                                </div>
                            ))
                        ) : (
                            <p>Please click below to create a new list.</p>
                        )}
                    </div>
                </Col>
            </Row>

            <GroceryListModal
                show={showModal}
                handleClose={handleCloseModal}
                currentList={currentList}
                fetchGroceryLists={fetchGroceryLists}
                refreshLists={fetchGroceryLists} // Ensure the lists are refreshed after actions
            />
        </Container>
    );
};

export default GroceryLists;
